import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=f24d5a76&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"
import style0 from "./Resume.vue?vue&type=style&index=0&id=f24d5a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24d5a76",
  null
  
)

export default component.exports